module.exports = __webpack_public_path__ + "img/thumb_27.4938a64b.jpg";